import { Box as MuiBox, styled } from '@mui/material'

import { ThemeToggle } from '@/components/ThemeToggle'
import { Box } from '@/components/ui'
import { spacing } from '@/themes/tokens'

interface ICenteredLayoutProps {
  children: React.ReactNode
}

const StyledContainer = styled(MuiBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
  backgroundColor: theme.palette.background.default,
  padding: theme.spacing(spacing.lg),
}))

const StyledContent = styled(MuiBox)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  flex: 1,
})

export const CenteredLayout = ({ children }: ICenteredLayoutProps) => {
  return (
    <StyledContainer>
      <StyledContent>{children}</StyledContent>
      <Box variant='flexEnd'>
        <ThemeToggle />
      </Box>
    </StyledContainer>
  )
}
